import React from "react";

export type TitleProps = {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    title?: string;
    titleHighlight?: string;
    highlightClassName?: string;
};

/**
 * Title component that renders a title with optional highlighted text.
 * If titleHighlight is contained within title, it splits and highlights all occurrences.
 * Otherwise, it appends titleHighlight after the title.
 */
export const Title: React.FC<TitleProps> = ({ level, title, titleHighlight, highlightClassName = "text-tertiary" }) => {
    if (!title) {
        return null;
    }

    if (!titleHighlight) {
        return <>{title}</>;
    }

    const tag = level ? `h${level}` : ("span" as const);

    // Check if titleHighlight is contained within title
    if (title.includes(titleHighlight)) {
        const parts = title.split(titleHighlight);
        // Handle multiple occurrences by joining all parts except the first
        return (
            <>
                {parts[0]}
                {parts.slice(1).map((part, index) => (
                    <React.Fragment key={index}>
                        {React.createElement(tag, { className: highlightClassName }, titleHighlight)}
                        {part}
                    </React.Fragment>
                ))}
            </>
        );
    }

    // Fallback: append titleHighlight after title
    return (
        <>
            {title} <span className={highlightClassName}>{titleHighlight}</span>
        </>
    );
};

export default Title;
